// extracted by mini-css-extract-plugin
export default {"item":"_16bda8f2","favorites":"_c69ff000","favoritesWrapper":"_30363e93","favoritesIconWrapper":"_fc38758"};